// extracted by mini-css-extract-plugin
export var indeterminate = "_25-6";
export var md = "_25-5";
export var semantic = "_25-7";
export var sm = "_25-4";
export var text = "_25-8";
export var toggleControl = "_25-0";
export var toggleInput = "_25-1";
export var toggleSwitch = "_25-2";
export var xs = "_25-3";